export const TOASTIFY_CONFIG = {
    position: "top-right",
    autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
};

export const TOASTIFY_CONTAINER_ID = "mainToastify";
